const CreatedByCell = ({ value }) => {
    if (!value) {
        return 'Former User';
    }
    return `${value.firstName} ${value.lastName}`;
};

export default CreatedByCell;
